export const ALL_COMPLETED_STAGE_GATE_ID = -20;
